import { Link } from 'react-router-dom';
import { Card } from '../components/ui';

export function NotFound() {
  return (
    <div className="narrow">
      <Card title="That page does not exist">
        <p className="muted">The link may be old, or the thing it pointed at may have been removed.</p>
        <Link className="btn btn-primary" to="/browse">
          Browse personas
        </Link>
      </Card>
    </div>
  );
}
